export const PROJECT_LIST_REQUEST = 'PROJECT_LIST_REQUEST';
export const PROJECT_LIST_SUCCESS = 'PROJECT_LIST_SUCCESS';
export const PROJECT_LIST_FAIL = 'PROJECT_LIST_FAIL';

export const PROJECT_DETAILS_REQUEST = 'PROJECT_DETAILS_REQUEST';
export const PROJECT_DETAILS_SUCCESS = 'PROJECT_DETAILS_SUCCESS';
export const PROJECT_DETAILS_FAIL = 'PROJECT_DETAILS_FAIL'; 